import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IApiBackendRouteService } from '../abstract/api-routes.service';
import { API_ENDPOINTS } from '../../../core/providers/constants/api.constants';
import { User } from '../types/users';
import { Department } from '../types/department';
import { WorkShift } from '../types/work-shift';
import { ScrapReason } from '../types/scrap-reason';
import { Stage } from '../types/stages';
import { InspectionQuantityType } from '../types/inspection-quantity-type';
import { DepartmentApiDto } from '../dto/department.dto';

@Injectable({
  providedIn: 'root',
})
export class ApiRouteDepartmentService extends IApiBackendRouteService {
  constructor(protected readonly http: HttpClient) {
    super();
  }

  urlRoute = `${API_ENDPOINTS.DEPARTMENTS}`;

  getAll(): Observable<Department[]> {
    return this.http.get<Department[]>(`${this.urlRoute}`);
  }

  getOneByName(name: string): Observable<Department> {
    return this.http.get<Department>(`${this.urlRoute}?name=${name}`);
  }

  getOne(id: number): Observable<Department> {
    return this.http.get<Department>(`${this.urlRoute}/${id}`);
  }

  getOperators(id: number): Observable<User[]> {
    return this.http.get<User[]>(`${this.urlRoute}/${id}/operators`);
  }

  getShifts(id: number): Observable<WorkShift[]> {
    return this.http.get<WorkShift[]>(`${this.urlRoute}/${id}/shifts`);
  }

  getScrapReasons(id: number): Observable<ScrapReason[]> {
    return this.http.get<ScrapReason[]>(`${this.urlRoute}/${id}/scrap`);
  }

  getStages(id: number): Observable<Stage[]> {
    return this.http.get<Stage[]>(`${this.urlRoute}/${id}/stages`);
  }

  getInspectionQuantityType(id: number): Observable<InspectionQuantityType> {
    return this.http.get<InspectionQuantityType>(
      `${this.urlRoute}/${id}/inspection-quantity`
    );
  }

  getFullData(name: string): Observable<Department> {
    return this.http.get<Department>(`${this.urlRoute}/full-data?name=${name}`);
  }

  getDataV2(
    name: string,
    paramsData: DepartmentApiDto['dataV2']['params'] = {}
  ): Observable<Department> {
    const { includeUsers, includeMachines, includeShifts, includeReasonScrap } =
      paramsData;
    let params = new HttpParams();
    if (includeUsers) {
      params = params.set('includeUsers', 'true');
    }
    if (includeMachines) {
      params = params.set('includeMachines', 'true');
    }
    if (includeShifts) {
      params = params.set('includeShifts', 'true');
    }
    if (includeReasonScrap) {
      params = params.set('includeReasonScrap', 'true');
    }
    return this.http.get<Department>(`${this.urlRoute}/data-v2?name=${name}`, {
      params,
    });
  }
}
